export default function isFieldViewPermissionAllowed({
  permissionName,
  action = "VIEW",
}) {
  let user = window.loggedInUser;

  if (!permissionName) return true;

  if (!user) return false;

  if (user.isSuperAdmin) return true;

  if (!user.role) return false;

  if (!user.role[permissionName]) return false;

  if (!user.role[permissionName].includes(action)) return false;

  return true;
}
